<template>

        <md-card>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>design_services</md-icon>
            </div>
            <h4 class="title">
              Service Information
            </h4>
          </md-card-header> -->
          <md-card-content>

            <div class="md-layout">
                <div class="md-layout-item">
              <autoextra :collection="license" v-slot="{item,last,index}">
              <div :class="{last: last}">
               <div v-if="item.driver_license_type || item.driver_license_type == 0 || last" class="columns">
                <label :id="'labelLicenseFlag__'+index" style="font-weight:bold;" class="label">{{last ? 'New ' : ''}}license {{!last ? index + 1 : ''}}</label>
                <div class="md-layout md-gutter">

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">
                  <input v-model="item.id" :readonly="true" type="hidden"/>

                  <div class="md-layout-item md-small-size-100" style="margin-top:25px;">
                    <md-field >
                      <label class="label" >License Type</label>
                      <md-select  v-model="item.driver_license_type" @md-selected="onChangeLicenseType()">
                        <md-option value="0">A</md-option>
                        <md-option value="1">A Umum</md-option>
                        <md-option value="2">B</md-option>
                        <md-option value="3">B2</md-option>
                        <md-option value="4">B2 Umum</md-option>
                        <md-option value="5">C</md-option>
                        <md-option value="6">B1</md-option>
                        <md-option value="7">B1 Umum</md-option>
                      </md-select>
                    </md-field>
                      <span :id="'flagLicenseType'" style="display:none; color:red;">Field is required</span>
                  </div>

                  <div class="md-layout-item md-small-size-100" style="margin-top:25px;">
                    <md-field >
                      <label class="label" >License No</label>
                      <md-input  v-model="item.driver_license_no" :disabled="!item.driver_license_type  && item.driver_license_type != 0" @change="onChangeLicenseNo(index, item.driver_license_no)"/>
                    </md-field>
                    <span :id="'flagLicense_'+index" style="display:none; color:red;">Field is required</span>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <label class="md-layout-item md-size-15 md-form-label">Expire Date</label>
                    <md-field >
                      <md-input type="date" v-model="item.driver_license_expire_date" :disabled="!item.driver_license_type && item.driver_license_type != 0"/>
                  
                    </md-field>
                  </div>


                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Address</label>
                      <md-textarea  v-model="item.driver_license_address" maxlength="100" md-autogrow :disabled="!item.driver_license_type && item.driver_license_type != 0"></md-textarea>
                      <md-avatar >
                        <md-icon style="color:blue;">report</md-icon>
                        <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                      </md-avatar>
                    </md-field>
                  </div>

                    <div class="md-layout-item md-small-size-100">
                      <validation-provider v-slot="{ errors }">
                      <md-field class="md-invalid">
                          <label >Photo license</label>
                          <md-file
                          ref="check_in"
                          @change="on_change_photo_license(item.driver_attach_license_view,index)"
                          v-model="item.driver_attach_license_view"
                          accept="image/jpeg,image/png"
                          :disabled="!item.driver_license_type && item.driver_license_type != 0"
                          />
                      <span class="md-error">{{ errors[0] }}</span>
                      </md-field>
                     <p v-if="item.driver_license_attach && item.driver_license_attach.type != 'image/jpeg' && item.driver_license_attach.type != 'image/png'" class="mb-0" style="text-align:center;">size: {{ (item.driver_license_attach.size / 1048576).toFixed(2) }}MB</p>
                      </validation-provider>
                    </div>
                  </div>

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">
                      <template v-if="item.driver_license_attach && (item.driver_license_attach.type == 'image/jpeg' || item.driver_license_attach.type == 'image/png')">
                          
                        <viewer class="pointer" :src="item.driver_license_attach.base64">
                          <img style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.driver_license_attach.base64" :alt="'driver license photo '+index" >
                        </viewer>
                        <p class="mb-0">
                            size: {{ (item.driver_license_attach.size / 1048576).toFixed(2) }}MB 
                        </p>
                        </template>
                        <template v-if="!item.driver_license_attach && item.url_driver_license_file">
                          <template v-if="get_url_extension_image(item.url_driver_license_file)">
                            <span style="color:green"
                              >Current Photo:
                            </span>
                            <viewer class="pointer" :src="item.url_driver_license_file">
                              <img style="width: auto; max-height:400px; display: block; margin:auto;" :src="item.url_driver_license_file" :alt="'driver license current photo '+index" >
                            </viewer>
                          </template>
                          <template v-else>
                          <span style="color:green"
                            >Current File:
                          </span>
                          <a target="_blank" :href="item.url_driver_license_file">{{item.url_driver_license_file.split('/').pop()}}</a>
                        </template>
                        </template>
                  </div>
                 
                  <md-card-actions style="border:none;">
                  <md-button class="md-danger md-dense" @click="deleteColumn(index)" v-if="item.driver_license_type || item.driver_license_type == 0">
                    delete
                  </md-button>
                </md-card-actions>
                </div>      
              </div>      
              </div>
            </autoextra>
            </div>
            </div>
          </md-card-content>
        </md-card>  
</template>
<script>
// import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
  // import {extend} from 'vee-validate';
  // import { required } from 'vee-validate/dist/rules';
import  Autoextra  from 'vue-autoextra';
import Swal from "sweetalert2";


export default {
  name: "license-card",
props: ['driver'],

  components: {  Autoextra },

  mixins: [formMixin],
 
  data() {
    return {
     license:[],
    //  driver_license_photo:null,
    };
  },
  
  created() {
          this.onOpen()
  },
  
  methods:{
    //fungsi saat pertamakali page di buka
    async onOpen(){
     
    },

      //ambil data dari parent, digunakan saat edit
      async getDataParent() { 
        // console.log(this.driver.driver_license);
        // this.license = this.driver.driver_license
        //loop nilai license untuk membuat autoextra row
        this.driver.driver_license.forEach((value, index) => {
          this.$set(this.license, index, {
                  id : value.id,
                  driver_license_type : value.driver_license_type,
                  driver_license_no : value.driver_license_no,
                  driver_license_expire_date : value.driver_license_expire_date,
                  driver_license_address : value.driver_license_address,
                  driver_license_attach : null,
                  driver_attach_license_view : null,
                  url_driver_license_file : value.url_driver_license_file,
                });
          });
        console.log(this.license);
      },

    onChangeLicenseNo(index,data){
        let error = document.getElementById("flagLicense_"+index);
        console.log(error)
        if(data!=null && data!=""){
        error.style.display = "none"
        }
        else{
          error.style.display = "block"
        }

      },

      get_url_extension_image(url) {
        const image_format = ["jpg", "jpeg", "pjpeg", "pjp", "png", "svg", "webp"];
        return image_format.includes(url.split(/[#?]/)[0].split('.').pop().trim());
    },


    onChangeLicenseType(){
      let error = document.getElementById("flagLicenseType");
        error.style.display = "none"
      flagLicenseType
      var filter = this.license.filter(function(el) {
          //  console.log(el);
            return el != null;
          });
          console.log(filter)
          var int= 0
          for (const [key, value] of Object.entries(filter)) {
                        console.log(key);
                        console.log(value);
                        if(!value.driver_license_type && value.driver_license_type != 0){
                          int++
                        }
                        else{
                          console.log(key-int);
                          this.$set(this.license, key-int, {
                            id : value.id,
                            driver_license_type :value.driver_license_type,
                            driver_license_no : value.driver_license_no,
                            driver_license_expire_date : value.driver_license_expire_date,
                            driver_license_address : value.driver_license_address,
                            driver_license_attach : value.driver_license_attach,
                            driver_attach_license_view : value.driver_attach_license_view,
                            url_driver_license_file : value.url_driver_license_file,
                  
                            
                          });
                          if(int!=0){
                            this.$set(this.license, key, {
                              id : null,
                              driver_license_type : null,
                              driver_license_no : null,
                              driver_license_expire_date : null,
                              driver_license_address : null,
                              driver_license_attach : null,
                              driver_attach_license_view : null,
                              url_driver_license_file : null,
                              
                              
                            });
                          }
                          
                          int= 0
                        }
                        

                      }
      
    },


      on_change_photo_license(event,index) {
      var input = event.target;
      if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          
          this.$set(this.license, index, {
                  id : this.license[index].id,
                  driver_license_type : this.license[index].driver_license_type,
                  driver_license_no : this.license[index].driver_license_no,
                  driver_license_expire_date : this.license[index].driver_license_expire_date,
                  driver_license_address : this.license[index].driver_license_address,
                  driver_license_attach : null,
                  driver_attach_license_view : null,
                  url_driver_license_file : this.license[index].url_driver_license_file,
                  
                });
          


          return
        }
      //check apakah data ada
      if (input.files) {
        var reader = new FileReader();
        //read file
        reader.onload = (e) => {
          //set array filedata
          const fileData = {
            name: input.files[0].name,
            size: input.files[0].size,
            lastModified: input.files[0].lastModified,
            lastModifiedDate: input.files[0].lastModifiedDate,
            type: input.files[0].type,
            base64: e.target.result,
          };
          //set var berdasarkan fildedata
          this.$set(this.license, index, {
                  id : this.license[index].id,
                  driver_license_type : this.license[index].driver_license_type,
                  driver_license_no : this.license[index].driver_license_no,
                  driver_license_expire_date : this.license[index].driver_license_expire_date,
                  driver_license_address : this.license[index].driver_license_address,
                  driver_attach_license_view : fileData.name,
                  driver_license_attach : fileData,
                  url_driver_license_file : this.license[index].url_driver_license_file,
                  
                  
                });
        };
        reader.readAsDataURL(input.files[0]);
      }
    },

    sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },

    
    // focusNoEstimate(){
    //     // this.$refs.driver_no_input.$el.focus();
    //     this.$refs.driver_create_at_datetime_input.$el.focus();
      
    // },
    //fungsi untuk menghapus colum license
    deleteColumn(index){
        if (index > -1) {
           this.license.splice(index, 1)
            // var filtered = this.license.filter(function (el) {
            //   return el != null;
            // });
            // this.license = filtered;
        }
        // console.log(this.license);
        
      },
      getData() { 
        var filter = this.license.filter(function(el) {
           console.log(el);
            return el != null;
          });
            this.$emit('data', filter)
        },

      async validateForm() {
            
        let result = []
        if(Object.keys(this.license).length != 0){
          for (const [key, value] of Object.entries(this.license)) {
            console.log(value.driver_license_no+' - '+value.driver_license_expire_date)
            if((value.driver_license_type || value.driver_license_type == 0) && !value.driver_license_no){
              if(!value.driver_license_no){
                document.getElementById("flagLicense_"+key).style.display = "block"
              }
              document.getElementById("labelLicenseFlag_"+key).scrollIntoView({behavior: 'auto'});
              result.push(false)
            }
          }
        }

        if(this.license.length == 0){
              document.getElementById("flagLicenseType").style.display = "block"
              document.getElementById("labelLicenseFlag_0").scrollIntoView({behavior: 'auto'});
              result.push(false)
        }
        return result.every(Boolean)
      }
    },
};
</script>

<style scoped>

.photo_list{
    max-width: 50%;
    height: auto;
    display: block;
    /* margin-left: auto;
    margin-right: auto; */
}

.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}</style>
